"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOtherAdjustmentFrontendSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.addOtherAdjustmentFrontendSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['amount', 'code', 'indexNumber', 'originalClaimSequenceNumber'],
    properties: {
        code: {
            type: 'string',
            enum: Object.values(constants_1.OtherAdjustmentCode),
            errorMessage: 'Should equate to a valid OtherAdjustmentCode Enum value',
        },
        amount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'Should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        comment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters',
        },
        indexNumber: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        originalClaimSequenceNumber: {
            type: 'number',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'Should be an integer between 0 and 32767',
        },
    },
    allOf: [
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        enum: [constants_1.OtherAdjustmentCode.OtherAdjustment, constants_1.OtherAdjustmentCode.OtherAdjustment2],
                    },
                },
            },
            then: {
                required: ['comment'],
            },
        },
    ],
};
